import Stop from "./stop";
import Utilities from "./utilities";

const $tripPlanner = document.getElementById( 'tm__trip-planner' ),
	$directionsRenderer = document.getElementById( 'tm__directions-renderer' );
let directionsService,
	directionsRenderer,
	transitResult = {routes: []},
	infowindowWasOpen;

const Directions = {
	init: async ( tm ) => {
		Directions.initTimeDateFields();
		await Directions.initAutocomplete();

		directionsService = new google.maps.DirectionsService();
		directionsRenderer = new google.maps.DirectionsRenderer( {
			map: tm.map,
			panel: $directionsRenderer,
			preserveViewport: true
		} );

		$tripPlanner.addEventListener( 'submit', e => {
			e.preventDefault();
			const params = Directions.parseDirectionsForm();
			Directions.recordTripRequest( tm, params );
			Directions.displayRoute( tm, params );
		} );

		tm.$sidebar.addEventListener( 'tm__change-tab', ( e ) => {
			let [newTab, oldTab, newIndex, oldIndex] = Utilities.getMissingTabsOrIndices( tm, e.detail );
			if ( typeof newIndex === 'undefined' || typeof oldIndex === 'undefined' ) return;

			if ( !transitResult.routes.length ) return;

			if ( newIndex === 1 ) {
				// switched to Trip Planner tab
				Directions.showDirectionsInsteadOfRoutesAndStops( tm );
			} else
				if ( oldIndex === 1 ) {
					// switched away from Trip Planner tab
					Directions.showRoutesAndStopsInsteadOfDirections( tm );
					Directions.setBoundsViaHack( tm );
				}
		} );

		// submit form if "timestamp" parameter exists in the query string (i.e. landed here from the NW Connector homepage)
		window.requestAnimationFrame( function () {
			const urlParams = new URLSearchParams( window.location.search );
			if ( urlParams.has( 'timestamp' ) ) {
				$tripPlanner.querySelector( 'input[type="submit"]' ).click();
			}
		} );
	},

	initAutocomplete: async () => {
		const {Autocomplete} = await google.maps.importLibrary( "places" );
		const options = {
			fields: ["formatted_address"],
			componentRestrictions: {country: "us"},
			bounds: {
				west: - 123.562,
				east: - 121.074,
				north: 45.987,
				south: 44.697,
			}
		};
		new google.maps.places.Autocomplete( document.getElementById( "tm__trip-start" ), options );
		new google.maps.places.Autocomplete( document.getElementById( "tm__trip-destination" ), options );
	},

	setBoundsViaHack: ( tm ) => {
		Utilities.zoomToBounds( tm, tm.currentBounds, false );

		// the hack
		// there's a bug where the map is set to the right bounds, but it displays the wrong bounds until you manually pan it, and then it jumps into place
		// the bug only seems to occur when switching back to a couple specific agencies (i.e. CAT and MHX), overview and route panels seem fine
		const centerLatLng = tm.map.getCenter();
		const newCenterLatLng = new google.maps.LatLng(
			centerLatLng.lat() + 0.01,
			centerLatLng.lng()
		);
		tm.map.panTo( newCenterLatLng );
	},

	showRoutesAndStopsInsteadOfDirections: ( tm ) => {
		// hide directions
		directionsRenderer.setDirections( {routes: []} );

		// show routes
		tm.map.data.setMap( tm.map );

		// show stops, if we're zoomed into a route
		if ( tm.visible.routeId && tm.stopLayers ) {
			tm.stopLayers[tm.visible.agencyId].setMap( tm.map );
		}

		// re-open infowindow, if it had previously been opened
		if ( infowindowWasOpen ) {
			Stop.getStopInfowindow().setMap( tm.map );
			Stop.addInfowindowOpenClass();
		}
	},

	showDirectionsInsteadOfRoutesAndStops: ( tm ) => {
		// show directions
		directionsRenderer.setDirections( transitResult );

		// adjust bounds
		let bounds = new google.maps.LatLngBounds();
		for ( let i = 0; i < transitResult.routes.length; i ++ ) {
			bounds.union( transitResult.routes[i].bounds );
		}
		Utilities.zoomToBounds( tm, bounds, false );

		// hide routes
		tm.map.data.setMap( null );

		// hide stops
		if ( tm.stopLayers ) {
			for ( const agencyId in tm.stopLayers ) {
				tm.stopLayers[agencyId].setMap( null );
			}
		}

		// hide stop infowindow, but remember whether it was opened or not
		infowindowWasOpen = !!Stop.getStopInfowindow().getMap();
		if ( infowindowWasOpen ) Stop.getStopInfowindow().setMap( null );
	},

	initTimeDateFields: () => {
		const timeTypeDropdown = $tripPlanner.elements.timeType,
			$timeLabel = $tripPlanner.querySelector( '.tm__time-label' ),
			$dateLabel = $tripPlanner.querySelector( '.tm__date-label' ),
			timeField = $tripPlanner.elements.time,
			dateField = $tripPlanner.elements.date;

		timeTypeDropdown.addEventListener( 'change', e => {
			$timeLabel.hidden = (e.target.value === 'now');
			$dateLabel.hidden = (e.target.value === 'now');

			// autofill with current time/date if selecting something besides "leave now"
			if ( e.target.value !== 'now' && !timeField.value && !dateField.value ) {
				let now = new Date();
				timeField.value = now.getHours().toString().padStart( 2, '0' ) + ':' + now.getMinutes().toString().padStart( 2, '0' );
				dateField.value = now.toISOString().split( 'T' )[0];
			}
		} );

		timeTypeDropdown.dispatchEvent( new Event( 'change' ) );
	},

	parseDirectionsForm: () => {
		const origin = $tripPlanner.elements.origin.value,
			destination = $tripPlanner.elements.destination.value,
			timeType = $tripPlanner.elements.timeType.value,
			timeKey = (timeType === 'arrive') ? 'arrivalTime' : 'departureTime';

		// if user didn't choose "leave now", pass along the user-submitted timestamp, if it's valid
		let timeVal = new Date();
		if ( timeType !== 'now' ) {
			let arbitraryDateObject = new Date( $tripPlanner.elements.date.value + ' ' + $tripPlanner.elements.time.value );
			if ( !isNaN( arbitraryDateObject.getTime() ) ) {
				timeVal = arbitraryDateObject;
			}
		}
		return [origin, destination, timeKey, timeVal];
	},

	recordTripRequest: ( tm, params ) => {
		const [origin, destination, timeKey, timeVal] = params;
		if ( !origin || !destination || !timeKey || !timeVal ) return;

		const nonce = tmVars.nonce,
			timeType = timeKey === 'departureTime' ? 'Depart At' : 'Arrive By',
			timestamp = parseInt( timeVal.getTime() / 1000, 10 ),
			requestData = {
				action: 'record_trip_request',
				nonce: nonce,
				origin: origin,
				destination: destination,
				timeType: timeType,
				timestamp: timestamp,
			};

		fetch( tmVars.ajaxUrl, {
			method: 'POST',
			headers: {'Content-type': 'application/x-www-form-urlencoded'},
			body: new URLSearchParams( requestData ).toString(),
		} )
			.then( response => {
				if ( !response.ok ) {
					console.error( 'Failed to record trip request.' );
				}
			} )
			.catch( error => {
				console.error( 'An error occurred while recording trip request:', error );
			} );
	},

	displayRoute: ( tm, params ) => {
		const [origin, destination, timeKey, timeVal] = params,
			args = {
				origin: origin,
				destination: destination,
				travelMode: 'TRANSIT',
				transitOptions: {},
			};
		args.transitOptions[timeKey] = timeVal;

		directionsService
			.route( args )
			.then( ( result ) => {
				$directionsRenderer.textContent = '';
				transitResult = result;
				Directions.showDirectionsInsteadOfRoutesAndStops( tm );
				tm.$sidebar.dataset.hasDirectionsResults = 'true';
			} )
			.catch( ( e ) => {
				// Possible status codes: https://developers.google.com/maps/documentation/directions/get-directions#DirectionsStatus
				// Supply friendlier messages for the most likely errors
				if ( e.code === 'NOT_FOUND' ) {
					$directionsRenderer.textContent = 'Could not geocode one or both locations. Please rewrite the addresses or try different locations.';
				} else
					if ( e.code === 'ZERO_RESULTS' ) {
						$directionsRenderer.textContent = 'No route found between these locations.';
					} else {
						$directionsRenderer.textContent = e;
					}
				console.warn( e );
			} );
	}
}

export default Directions;
